'use strict';

var _ = require('lodash');
var ConfigurationHostShareTransformerFactory = function ConfigurationHostShareTransformerFactory(DataTransformer) {
  function ConfigurationHostShareTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-host-share-mode';
    this.priority = 1;
  }
  ConfigurationHostShareTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationHostShareTransformer.constructor = ConfigurationHostShareTransformer;
  ConfigurationHostShareTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationHostShareTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationHostShareTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationHostShareTransformer.prototype.transform = function (data) {
    return _.map(data.domain.flattenedHostShares, function (item) {
      item.diff = Math.abs(item.hostShare - item.hostShareNew);
      return item;
    });
    //return data.domain.flattenedHostShares;
  };
  return ConfigurationHostShareTransformer;
};
ConfigurationHostShareTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = ConfigurationHostShareTransformerFactory;